"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomerEntityType = exports.SantanderCustomerType = exports.BosCustomerType = exports.CustomerType = void 0;
// Used to determine the type of the customer a calculation belongs to, relevant for VAT and possibly employee discount.
var CustomerType;
(function (CustomerType) {
    CustomerType[CustomerType["PRIVATE"] = 0] = "PRIVATE";
    CustomerType[CustomerType["BUSINESS"] = 1] = "BUSINESS";
    CustomerType[CustomerType["EMPLOYEE"] = 2] = "EMPLOYEE";
})(CustomerType = exports.CustomerType || (exports.CustomerType = {}));
var BosCustomerType;
(function (BosCustomerType) {
    BosCustomerType["PRIVATE"] = "P";
    BosCustomerType["BUSINESS"] = "B";
})(BosCustomerType = exports.BosCustomerType || (exports.BosCustomerType = {}));
// Used to determine whether a customer is a person or a business
var SantanderCustomerType;
(function (SantanderCustomerType) {
    SantanderCustomerType["PRIVATE"] = "Private";
    SantanderCustomerType["BUSINESS"] = "Company";
})(SantanderCustomerType = exports.SantanderCustomerType || (exports.SantanderCustomerType = {}));
// Used to determine whether the ID field in a calculation maps to the contact entity or the customer entity in BOS api
var CustomerEntityType;
(function (CustomerEntityType) {
    CustomerEntityType["CONTACT"] = "contact";
    CustomerEntityType["CUSTOMER"] = "customer";
    CustomerEntityType["EXTERNAL"] = "external";
})(CustomerEntityType = exports.CustomerEntityType || (exports.CustomerEntityType = {}));
//# sourceMappingURL=customer.js.map